export default "__VITE_ASSET__faCMsd1d__"